'use es6';

const VALID_UUID_CHECK = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
const isValidUuid = token => VALID_UUID_CHECK.test(token);
export default isValidUuid;